<template>
    <section class="tk-card">
        <div class="tk-card-header">
            <h2>Client Information</h2>
            <q-btn
                flat
                dense
                no-caps
                color="primary"
                label="View details"
                @click="$emit('open')"
            />
        </div>

        <div class="tk-information-snapshot">
            <section>
                <h3>Person Details</h3>
                <dl>
                    <div v-for="field in personFields" :key="field.label">
                        <dt>{{ field.label }}</dt>
                        <dd>{{ field.value }}</dd>
                    </div>
                </dl>
            </section>

            <section>
                <h3>Contact Details</h3>
                <dl>
                    <div v-for="(field, index) in contactFields" :key="`${field.label}-${index}`">
                        <dt>{{ field.label }}</dt>
                        <dd>
                            <a v-if="field.href" :href="field.href">{{ field.value }}</a>
                            <span v-else>{{ field.value }}</span>
                        </dd>
                    </div>
                </dl>
            </section>

            <section>
                <h3>Referral Source</h3>
                <p>{{ engagement.referralSource }}</p>
            </section>
        </div>
    </section>
</template>

<script>
import {
    personContactRows,
    personFullName,
} from "@/services/util/tkClients";

export default {
    name: "TkEngagementInformationSnapshot",
    emits: ["open"],
    props: {
        engagement: {
            type: Object,
            required: true,
        },
    },
    computed: {
        fullName() {
            const name = personFullName(this.engagement);
            return name || this.engagement.personName || "-";
        },
        personFields() {
            return [
                { label: "Full name", value: this.fullName },
                { label: "Preferred name", value: this.engagement.preferred_name || "-" },
                { label: "DOB", value: this.engagement.dateOfBirth },
            ];
        },
        contactFields() {
            return personContactRows(this.engagement);
        },
    },
};
</script>

<style scoped>
.tk-information-snapshot {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
}

.tk-information-snapshot section {
    min-width: 0;
}

.tk-information-snapshot section + section {
    padding-left: 24px;
    border-left: 1px solid rgba(47, 62, 70, 0.08);
}

.tk-information-snapshot h3 {
    margin: 0 0 10px;
    color: #46544e;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.025em;
}

.tk-information-snapshot dl {
    display: grid;
    gap: 8px;
    margin: 0;
}

.tk-information-snapshot dl div {
    display: grid;
    gap: 2px;
}

.tk-information-snapshot dt {
    color: #748078;
    font-size: 0.76rem;
}

.tk-information-snapshot dd,
.tk-information-snapshot p {
    margin: 0;
    color: #3c4b45;
    font-size: 0.88rem;
    font-weight: 550;
    line-height: 1.3;
    overflow-wrap: anywhere;
}

.tk-information-snapshot a {
    color: #2f6f5e;
    text-decoration: none;
}

.tk-information-snapshot a:hover {
    text-decoration: underline;
}

@media (max-width: 760px) {
    .tk-information-snapshot {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .tk-information-snapshot section + section {
        padding-top: 16px;
        padding-left: 0;
        border-top: 1px solid rgba(47, 62, 70, 0.08);
        border-left: 0;
    }
}
</style>
